<script>
import BoardCard from "@/components/BoardCard.vue";
import { Line } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  PointElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  LineElement
} from 'chart.js'

ChartJS.register(Title, PointElement, Tooltip, Legend, LineElement, CategoryScale, LinearScale)

export default {
  name: 'ErrorStat',
  components: {BoardCard, Line},
  props: {
    title: {
      type: String,
      default: "Ошибки"
    }
  },
  data() {
    return {
      chartData: null,
      chartOptions: {
        responsive: true,
        interaction: {
          intersect: false,
        },
      }
    }
  },
  methods: {
    loadData: function () {
      console.log("load token")
      let c = this;
      c.chartData = null;
      c.loading = true;
      c.error = false;
      this.axios.get('/api/log/dashboard/error-stat').then(function(response) {
        console.log(response.data);
        c.chartData = response.data.data;
        c.loading = false;
      }).catch(function(err) {
        console.log(err.status);
        c.loading = false;
        c.error = true;
      });
    }
  },
  mounted() {
    this.loadData();
  }
}
</script>

<template>
  <BoardCard :title="title" v-if="chartData != null">
    <Line
        id="log-size-stat"
        :options="chartOptions"
        :data="chartData"/>
  </BoardCard>
</template>

<style scoped>

</style>